if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkoutButtons = document.querySelectorAll('[data-cart-checkout-button]');

      if (this.checkbox && this.checkoutButtons.length) {
        this.toggleCheckoutButton();

        this.checkbox.addEventListener('change', () => {
          this.toggleCheckoutButton();
        });
      }
    }

    toggleCheckoutButton() {
      const checkboxes = document.querySelectorAll('terms-checkbox input[type="checkbox"]');
      const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
      const disabled = !allChecked;

      this.checkoutButtons.forEach((button) => {
        button.disabled = disabled;
      });
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
